import { render } from "./TablePrefectureAnalysis.vue?vue&type=template&id=2df7ea6e"
import script from "./TablePrefectureAnalysis.vue?vue&type=script&lang=js"
export * from "./TablePrefectureAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__